const encodeQueryParam = (key: string, value: string | boolean | number) => {
  return encodeURIComponent(key) + '=' + encodeURIComponent(value);
};

export const buildQueryObject = (params: Record<string, string | boolean | number>) => {
  const newParams: Record<string, string | boolean | number> = {};

  Object.keys(params)
    .filter(
      (key) =>
        params[key] !== undefined &&
        params[key] !== null &&
        params[key] !== '' &&
        params[key] !== '_all' &&
        params[key] !== 'ALL',
    )
    .forEach((key) => (newParams[key] = params[key]));

  return newParams;
};

export const buildQueryString = (params: Record<string, string | boolean | number>) => {
  return Object.keys(params)
    .filter(
      (key) =>
        params[key] !== undefined &&
        params[key] !== null &&
        params[key] !== '' &&
        params[key] !== '_all' &&
        params[key] !== 'ALL',
    )
    .map((key) => encodeQueryParam(key, params[key]))
    .join('&');
};

export const parseQueryString = (queryString: string) => {
  try {
    const queryParams = new URLSearchParams(queryString);

    return Object.fromEntries(queryParams.entries());
  } catch (e) {
    console.error(e);
  }
  return {};
};
